/**
 * Parses an API timestamp as UTC. The generated client's types say Date, but values arrive as
 * strings at runtime, and the backend can send UTC without a trailing 'Z' (which the browser
 * would otherwise read as local time).
 */
export const parseUtc = (value: Date | string | undefined | null): Date | null => {
  if (!value) return null;
  if (value instanceof Date) return isNaN(value.getTime()) ? null : value;

  let dateString = value.trim();
  if (dateString && !dateString.endsWith('Z') && !/[+-]\d{2}:\d{2}$/.test(dateString)) {
    dateString += 'Z';
  }

  const date = new Date(dateString);
  return isNaN(date.getTime()) ? null : date;
};
